import React, { useContext } from 'react'
import IButton from '../../assets/i-button-logo.svg'
import DraftButton from '../../assets/draft-button-logo.png'
import { getThumbnail } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
const IPTVContentCard = ({
  data,
  cardSize = 'md',
  cardWidth,
  cardHieght,
  cardMarginTop,
  isDraft = false,
  isDaily = false,
  onPreviewClick,
}) => {
  const { userSessionObj } = useContext(GlobalContext)
  const imgStyleObj = {
    sm: {
      width: '2.21354vw',
      height: '1.302vw',
    },
    md: {
      width: '4.427vw',
      height: '2.604vw',
    },
    lg: {
      width: '7vw',
      height: '4vw',
    },
  }
  return (
    <div
      style={{
        backgroundColor: isDraft ? '#ffd4a2' : '#e2e2e2',
        width: cardWidth,
        height: cardHieght,
        marginTop: cardMarginTop,
        zIndex: '2',
        borderRadius: '4px',
      }}
      className="position-absolute overflow-hidden "
    >
      <div className="d-flex w-100 h-100 position-relative">
        <div
          style={{ width: '7px', background: isDraft ? '#ee7f00' : '#000' }}
          className="h-100 mr-1"
        ></div>
        <div
          //   style={{ border: '1px solid red' }}
          className={`  ${
            isDaily
              ? 'd-flex ml-3 pt-2.5'
              : cardSize === 'sm' || cardSize === 'xs'
              ? 'py-1'
              : 'ml-1 py-2'
          }`}
        >
          {cardSize !== 'xs' && (
            <img
              src={getThumbnail(
                userSessionObj.session_data.cf_domain_name,
                data?.thumbnail?.website?.s3_key,
              )}
              style={imgStyleObj[cardSize]}
              className=""
            />
          )}

          <div className={`${isDaily ? ' ml-3' : ''}`}>
            <p
              style={{
                fontSize: '0.625vw',
                fontWeight: '500',
                width: cardSize === 'sm' || cardSize === 'xs' ? '90%' : '100%',
              }}
              className={`mb-0 ${
                cardSize === 'sm' || cardSize === 'xs' || isDaily ? 'line-clamp-1' : 'mt-1'
              }`}
            >
              {data.title}
            </p>
            {cardSize !== 'sm' && cardSize !== 'xs' && (
              <div
                style={{ fontSize: '0.55vw', color: '#676767' }}
                className="mr-2 w-100 d-flex justify-content-between"
              >
                <span className="w-100 line-clamp-1">{data.categoryStr}</span>
                {/* <span className="w-50 text-right">Duration: {data.duration}</span> */}
              </div>
            )}
          </div>
        </div>
        <div
          className={`position-absolute end-0 d-flex ${
            cardSize !== 'sm' && cardSize !== 'xs' ? 'py-2' : 'py-1'
          } `}
        >
          {isDraft && (
            <img src={DraftButton} style={{ width: '38px', height: '16px' }} className="" />
          )}

          <img
            src={IButton}
            style={{ width: '16px', height: '16px' }}
            className="mx-2 cursor-pointer"
            onClick={onPreviewClick}
          />
        </div>
      </div>
    </div>
  )
}

export default IPTVContentCard
